import { render, staticRenderFns } from "./Fabric.vue?vue&type=template&id=cc617308&"
import script from "./Fabric.vue?vue&type=script&lang=js&"
export * from "./Fabric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports